import React from "react";
import styles from './form.module.css'

const Checkbox = ({ checked, pink = false }) => {
    return (
        <div className={`${styles.checkbox} ${checked && styles.active} ${pink ? styles.pink : ''}`} />
    )
}

export default Checkbox